import { ChangeDetectorRef, ComponentRef, Directive, Input, OnChanges, Type, ViewContainerRef } from '@angular/core';
import { MarkerInfoState } from './marker-info.state';

@Directive()
export abstract class SharedMarkerFactory extends MarkerInfoState implements OnChanges {
  @Input({ required: false }) public kind: string;

  protected abstract componentsMapper: { [key: string]: Type<MarkerInfoState> };

  private componentRef: ComponentRef<MarkerInfoState>;

  public ngOnChanges(): void {
    if (this.componentRef) {
      this.componentRef.destroy();
    }

    if (this.kind) {
      this.loadComponent();
    }
  }

  protected abstract getViewContainer(): ViewContainerRef;

  private loadComponent(): void {
    if (!this.componentsMapper[this.kind]) {
      console.error(`Error: Trying to use an unsupported type ${this.kind}.`);
      return;
    }

    const viewContainer = this.getViewContainer();
    this.componentRef = viewContainer.createComponent(this.componentsMapper[this.kind]);

    this.setComponentData();
    this.subscribeToEvents();
  }

  private setComponentData(): void {
    this.componentRef.instance.data = this.data;
    this.componentRef.instance.index = this.index;
    this.componentRef.instance.isLoggedIn = this.isLoggedIn;
    this.componentRef.instance.isAdminSession = this.isAdminSession;
    this.componentRef.instance.isActive = this.isActive;

    this.componentRef.instance.tooltips = this.tooltips;
    this.componentRef.instance.itemsCount = this.itemsCount;
    this.componentRef.instance.itemsKind = this.itemsKind;

    this.componentRef.injector.get(ChangeDetectorRef).detectChanges();
  }

  private subscribeToEvents(): void {
    this.componentRef.instance.itemClicked.subscribe(() => this.itemClicked.emit());
  }
}
